import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthShell, googleLogin } from "./AuthShell";
import { Btn, Field } from "@/components/ui-kit";
import { api, formatError } from "@/api";
import { useAuth } from "@/auth";
import { toast } from "sonner";

export default function Login() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data);
      toast.success("Tervetuloa takaisin!");
      navigate(data.role === "admin" ? "/admin" : data.role ? "/dashboard" : "/valitse-rooli-google", { replace: true });
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Kirjaudu sisään" subtitle="Tervetuloa takaisin Creatoriin." testid="login-page">
      <form onSubmit={submit} className="space-y-4">
        <Field label="Sähköposti" type="email" value={form.email} required
          onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email" />
        <Field label="Salasana" type="password" value={form.password} required
          onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password" />
        <div className="flex justify-end -mt-1">
          <span className="text-sm font-medium text-[#292827] cursor-pointer hover:underline"
            onClick={() => navigate("/unohtui-salasana")} data-testid="forgot-password-link">Unohditko salasanasi?</span>
        </div>
        <Btn type="submit" disabled={loading} className="w-full" data-testid="login-submit">
          {loading ? "Kirjaudutaan..." : "Kirjaudu"}
        </Btn>
      </form>
      <div className="my-6 flex items-center gap-3 text-xs text-[#968F85]">
        <div className="flex-1 h-px bg-[#E6E1D9]" /> TAI <div className="flex-1 h-px bg-[#E6E1D9]" />
      </div>
      <Btn variant="outline" className="w-full" onClick={googleLogin} data-testid="login-google">
        Jatka Googlella
      </Btn>
      <p className="mt-6 text-center text-sm text-[#6E675C]">
        Ei vielä tiliä?{" "}
        <span className="font-medium text-[#292827] cursor-pointer hover:underline" onClick={() => navigate("/valitse-rooli")} data-testid="to-register">Rekisteröidy</span>
      </p>
    </AuthShell>
  );
}
